/* eslint-disable import/prefer-default-export */

import {
	UPDATE_VIEWPORT,
	UPDATE_LOGIN_STATUS,
} from '../types/global';

export const setViewport = (viewport) => {
	return {
		type: UPDATE_VIEWPORT,
		viewport,
	};
};

export const setLoggedInStatus = (loggedIn) => {
	return {
		type: UPDATE_LOGIN_STATUS,
		loggedIn,
	};
};
